import { useContext } from 'react';
import { AppProvider, AppContext } from './context/AppContext';
import { Shell } from './components/layout/Shell';
import { Toast } from './components/common';
import { AddUserModal, OnboardingModal } from './components/modals';
import { LoginPage, MyEarningsPage, AdminFinancialPage, KPIMetricsPage } from './pages';

/**
 * Main App Content
 * Handles routing, modals, and toast notifications
 */
function AppContent() {
  const ctx = useContext(AppContext);
  
  if (!ctx) {
    return <div style={{ color: '#fff', padding: 32 }}>Loading...</div>;
  }

  const {
    currentUser,
    page,
    modal,
    closeModal,
    toast,
    logout,
    users,
    restaurants,
    userCommissions,
    allCommissions,
    loadingCommissions,
    markCommissionPaid,
    bulkMarkCommissionsPaid,
    showToast,
    login,
    loadUsers,
  } = ctx;

  // Show login page if not authenticated
  if (!currentUser) {
    return <LoginPage onLogin={login} showToast={showToast} />;
  }

  return (
    <Shell 
      currentUser={currentUser}
      page={page}
      setPage={ctx.setPage}
      onLogout={logout}
    >
      {/* Page Routing */}
      {page === 'contacts' && (
        <div style={{ padding: 32, textAlign: 'center', color: '#94a3b8' }}>
          <h1 style={{ fontSize: 32, marginBottom: 16 }}>🍽️ جهات الاتصال</h1>
          <p>ContactsPage will be extracted in the next iteration</p>
          <p style={{ fontSize: 12, marginTop: 8 }}>
            Total restaurants: {restaurants?.length || 0}
          </p>
        </div>
      )}

      {page === 'wallet' && (
        <MyEarningsPage 
          userCommissions={userCommissions}
          loadingCommissions={loadingCommissions}
        />
      )}

      {page === 'financial' && (
        <AdminFinancialPage 
          allCommissions={allCommissions}
          loadingCommissions={loadingCommissions}
          markCommissionPaid={markCommissionPaid}
          bulkMarkCommissionsPaid={bulkMarkCommissionsPaid}
        />
      )}

      {page === 'kpi' && (
        <KPIMetricsPage />
      )}

      {page === 'settings' && (
        <div style={{ padding: 32, textAlign: 'center', color: '#94a3b8' }}>
          <h1 style={{ fontSize: 32, marginBottom: 16 }}>⚙️ الإعدادات</h1>
          <p>SettingsPage will be extracted in the next iteration</p>
          <p style={{ fontSize: 12, marginTop: 8 }}>
            Current user: {currentUser.name} ({currentUser.role})
          </p>
        </div>
      )}

      {/* Modal Routing */}
      {modal?.type === 'add_user' && (
        <AddUserModal 
          isOpen={true}
          onClose={closeModal}
          showToast={showToast}
          onUserCreated={() => loadUsers()}
        />
      )}

      {modal?.type === 'onboarding' && (
        <OnboardingModal 
          restaurant={modal.data}
          isOpen={true}
          onClose={closeModal}
          showToast={showToast}
          currentUser={currentUser}
          onUpdateSuccess={() => {
            // Reload will be handled by hook
          }}
        />
      )}

      {/* Toast Notification */}
      {toast && <Toast msg={toast.msg} type={toast.type} />}
    </Shell>
  );
}

/**
 * Root App Component
 * Wraps everything in AppContext Provider
 */
export default function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}
